import PropTypes from 'prop-types';
import { ContentfulImageQueryPropTypes } from '@prospectus/common/ui/ContentfulImage/propTypes';

export const HeroPropTypes = {
  appearance: PropTypes.string,
  title: PropTypes.shape({
    raw: PropTypes.string.isRequired,
  }).isRequired,
  subtitle: PropTypes.string,
  imageAltText: PropTypes.string,
  theme: PropTypes.string,
  backgroundImageLarge: PropTypes.shape(ContentfulImageQueryPropTypes),
  backgroundImageMedium: PropTypes.shape(ContentfulImageQueryPropTypes),
  backgroundImageSmall: PropTypes.shape(ContentfulImageQueryPropTypes),
  cta: PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isExternal: PropTypes.bool.isRequired,
  }),
  cta2: PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isExternal: PropTypes.bool.isRequired,
  }),
  asset: PropTypes.shape(ContentfulImageQueryPropTypes),
  videoUrl: PropTypes.string,
  withOverlay: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export const HeroDefaultProps = {
  appearance: 'default',
  subtitle: undefined,
  imageAltText: '',
  theme: undefined,
  cta: undefined,
  cta2: undefined,
  backgroundImageSmall: undefined,
  backgroundImageMedium: undefined,
  backgroundImageLarge: undefined,
  asset: undefined,
  videoUrl: undefined,
  withOverlay: false,
};
